function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M19.75 7.938a5.687 5.687 0 01-6.143 5.67 5.695 5.695 0 00-5.215-5.216 5.687 5.687 0 1111.358-.455z",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.625 14.063a5.687 5.687 0 11-11.375 0 5.687 5.687 0 0111.375 0z",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M7.168 13.293l.77-1.418.77 1.418 1.417.77-1.418.77-.77 1.417-.77-1.418-1.417-.77 1.418-.77z",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgButCrypto(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none"
  }, props), _ref, _ref2, _ref3);
}

export default SvgButCrypto;